import {
  DEFAULT_TRT_APPT_CODE,
  DEFAULT_TRT_FOLLOW_UP_APPT_CODE,
  DEFAULT_TRT_RENEWAL_APPT_CODE
} from 'constants/defaults';

import { ProgramCode } from 'models/programs.types';

// Override of the default Men's Health (TRT) visit code per program.
// Empty for now — no tiered/club TRT program code exists yet. A future variant is a one-line addition here.
export const TRT_PROGRAM_APPT_CODE: Partial<Record<ProgramCode, string>> = {};

// All "Men's Health visit" codes (standard + program variants + renewal/follow-up),
// for membership checks ("is this any TRT visit code?").
export const TRT_APPT_CODES = [
  DEFAULT_TRT_APPT_CODE,
  DEFAULT_TRT_RENEWAL_APPT_CODE,
  DEFAULT_TRT_FOLLOW_UP_APPT_CODE,
  ...Object.values(TRT_PROGRAM_APPT_CODE)
];
